module.exports = __webpack_public_path__ + "static/media/alarm-clock-svgrepo-com.148ec2b4.svg";